import styles from './ShippingAddressCard.module.scss'

import clsx from 'clsx'
import { COUNTRY_CODES } from '../../consts'
import { AWCButton } from '../../GlobalComponents/Inputs/Inputs'

interface ShippingAddressCardProps {
    disabled?: boolean
    selected?: boolean
    shipTo: CustomerShipToViewRow
    last: boolean
    onSelect(): void
}
function ShippingAddressCard(props: ShippingAddressCardProps) {
    const { disabled, selected, shipTo, last, onSelect } = props
    let stCountry = shipTo.ShipToCountry && shipTo.ShipToCountry.trim()
    return (
        <div className={clsx(last && styles.cardContainerLast, styles.cardContainer)}>
            <AWCButton
                type={disabled ? 'disabled' : 'primary'}
                onClick={() => !disabled && !selected && onSelect()}
                style={{ marginBottom: 10, width: 'initial' }}
                selected={selected}
            >
                {selected ? 'Selected Address' : 'Select Address'}
            </AWCButton>
            <div className={styles.shipToLine}>{shipTo.ShipToName}</div>
            <div>{shipTo.ShipToAddress1 || ' '}</div>
            <div>{shipTo.ShipToAddress2}</div>
            <div>
                {shipTo.ShipToCity}, {shipTo.ShipToState!.trim()} {shipTo.ShipToZipcode}
            </div>
            <div>{COUNTRY_CODES[stCountry!] || stCountry}</div>
            {shipTo.isDefault && <div className={styles.defaultShipTo}>Default Address</div>}
        </div>
    )
}

export default ShippingAddressCard
